module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_06 (2).8bcdff88.png";